module.exports = __webpack_public_path__ + "static/img/wechat.b7701f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/discover/wechat.png
// module id = 274
// module chunks = 1